import React from 'react';
import { motion } from 'framer-motion';
import membershipImage from '../Screenshot 2025-05-03 222858.png'; // Adjust as needed

function Membership() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  const imageVariants = {
    hidden: { scale: 0.9, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 0.8, ease: "easeOut" }
    },
    hover: {
      scale: 1.03,
      transition: { duration: 0.3 }
    }
  };

  return (
    <section id="membership" style={{ padding: '4rem 1rem', backgroundColor: '#F9FAFB' }}>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
        className="membership-container"
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '3rem',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Text Content */}
        <motion.div
          style={{
            flex: '1 1 400px',
            minWidth: '300px',
            padding: '1rem',
          }}
          variants={itemVariants}
        >
          <motion.h2
            style={{
              fontSize: '2rem',
              fontWeight: '700',
              color: '#1F2937',
              marginBottom: '1rem',
              lineHeight: '1.3',
            }}
            variants={itemVariants}
          >
            Your Path to Prosperity
          </motion.h2>

          <motion.div
            style={{ width: '4rem', height: '0.25rem', backgroundColor: '#F59E0B', marginBottom: '1.5rem' }}
            variants={itemVariants}
          ></motion.div>

          <motion.p
            style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#4B5563',
              marginBottom: '2rem',
            }}
            variants={itemVariants}
          >
            Joining AIC is straightforward. With a minimum monthly contribution of <strong style={{ color: '#1F2937', fontWeight: '700' }}>AED 1,000 (USD 272) </strong>, you become a shareholder and gain voting rights. Whether you're experienced or just starting, we welcome you to our growing community.
          </motion.p>

          <motion.div
            style={{
              backgroundColor: '#FFFFFF',
              padding: '1.5rem',
              borderRadius: '0.75rem',
              boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
              marginBottom: '2rem',
            }}
            variants={itemVariants}
            whileHover={{ y: -5 }}
            transition={{ duration: 0.3 }}
          >
            <motion.h3
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1F2937',
                marginBottom: '1rem',
              }}
              variants={itemVariants}
            >
              Membership Benefits
            </motion.h3>

            <motion.ul
              style={{
                listStyleType: 'none',
                paddingLeft: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
              }}
              variants={containerVariants}
            >
              {[
                <span><strong style={{ color: '#1F2937', fontWeight: '700' }}>Collective Buying Power:</strong> Pool resources for better deals.</span>,
                <span><strong style={{ color: '#1F2937', fontWeight: '700' }}>Shared Expertise:</strong> Tap into a network of professionals.</span>,
                <span><strong style={{ color: '#1F2937', fontWeight: '700' }}>Democratic Governance:</strong> Every vote matters.</span>,
                <span><strong style={{ color: '#1F2937', fontWeight: '700' }}>Long-Term Wealth Building:</strong> Grow together.</span>
              ].map((item, index) => (
                <motion.li
                  key={index}
                  style={{
                    fontSize: '1rem',
                    color: '#4B5563',
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                  }}
                  variants={itemVariants}
                  whileHover={{ x: 5 }}
                >
                  <span style={{ color: '#F59E0B', fontSize: '1.25rem' }}>✓</span>
                  {item}
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          <motion.div variants={itemVariants}>
            <motion.a
              href="https://t.me/AICUAE"
              target="_blank"
              rel="noopener noreferrer"
              className="join-button"
              style={{
                display: 'inline-block',
                backgroundColor: '#1F2937',
                color: '#FFFFFF',
                padding: '0.75rem 2rem',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                fontWeight: '600',
                textDecoration: 'none',
              }}
              whileHover={{
                backgroundColor: '#111827',
                scale: 1.05,
              }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              Join Us Now
            </motion.a>
          </motion.div>
        </motion.div>

        {/* Image Content */}
        <motion.div
          style={{
            flex: '1 1 400px',
            minWidth: '300px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          variants={imageVariants}
          whileHover="hover"
          className="image-container"
        >
          <img
            src={membershipImage}
            alt="Membership"
            style={{
              width: '100%',
              maxWidth: '500px',
              height: 'auto',
              borderRadius: '1rem',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
            }}
          />
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Membership;